export function useWordPressLogin() {
  const host = window.location.host;

  const hostMap: Record<string, boolean> = {
    "eire.entry4sports.com": true,
    "entry.athleticsireland.ie": false,
    "entry4sports.co.uk": false,
    "localhost:5173": false,
    "localhost:5174": false,
  };

  let shouldEnvUseWordPressLogin = hostMap[host];
  console.log(
    "useWordPressLogin: host: " + host + ", env: " + shouldEnvUseWordPressLogin
  );
  if (!shouldEnvUseWordPressLogin) {
    console.error("ButtonGotoLiveResults: No env found for host: " + host);
    shouldEnvUseWordPressLogin = false;
  }

  return shouldEnvUseWordPressLogin;
}
